import Router from '@app/Router'
import { BrowserRouter } from 'react-router'

function App() {

  return (
    <BrowserRouter>
      <main>
        <Router/>
      </main>
    </BrowserRouter>
  )
}

export default App
